import { render, staticRenderFns } from "./ArticoloDrawer.vue?vue&type=template&id=7da4dc90&scoped=true&"
import script from "./ArticoloDrawer.vue?vue&type=script&lang=js&"
export * from "./ArticoloDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ArticoloDrawer.vue?vue&type=style&index=0&id=7da4dc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da4dc90",
  null
  
)

export default component.exports